import React, { useState, useEffect } from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import ImageSliderHero from "../main/sliderImage";
import SlidingTabs from "../main/categoryTab/CategoryTab";
import Newsstaller from "../shared/newsteller/Newsstaller";
import HomeVideoSection from "../shared/homeVideoSection/HomeVideoSection";

import Footer from "../shared/footer/Footer";
import LoginModal from "../main/loginModal/LoginModal";
import MobileSearchBar from "../Global/mobileSearchBar";
import MobileNav from "../Global/mobileNav";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import ImageSliderHeroMobile from "../main/SliderImageMobile";
import { generateDeviceId } from "../../services/createDeviceId";

const Home = () => {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(accessToken ? false : true);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    } 

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []); // Run on mount

  const dummyData = [
    {
      id: 4,
      title: "Art Gallery Opening Night",
      category: { name: "Arts" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746849503/Artboard_1_4_tyj1tc.svg",
      user_profile: {
        photo: "user4.jpg",
        first_name: "Emma",
        last_name: "Wilson",
      },
      event_date: "28-05-2023 20:00",
      city: "Chicago",
    },
    {
      id: 1,
      title: "Exclusive Wine Tasting Event",
      category: { name: "Food & Drink" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746849503/Artboard_1_5_zoj9iy.svg",
      user_profile: {
        photo: "user1.jpg",
        first_name: "John",
        last_name: "Smith",
      },
      event_date: "15-05-2023 19:00",
      city: "New York",
    },
    {
      id: 2,
      title: "Tech Entrepreneurs Meetup",
      category: { name: "Business" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746849503/Artboard_1_6_pcvpwr.svg",
      user_profile: {
        photo: "user2.jpg",
        first_name: "Sarah",
        last_name: "Johnson",
      },
      event_date: "20-05-2023 18:30",
      city: "San Francisco",
    },
    {
      id: 3,
      title: "Yoga & Meditation Retreat",
      category: { name: "Wellness" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746849503/Artboard_1_7_ibrx6r.svg",
      user_profile: {
        photo: "user3.jpg",
        first_name: "Michael",
        last_name: "Chen",
      },
      event_date: "25-05-2023 08:00",
      city: "Los Angeles",
    },
  ];
  const dummyData2 = [
    {
      id: 4,
      title: "Art Gallery Opening Night",
      category: { name: "Arts" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746852044/Artboard_19_mqhufm.svg",
      user_profile: {
        photo: "user4.jpg",
        first_name: "Emma",
        last_name: "Wilson",
      },
      event_date: "28-05-2023 20:00",
      city: "Chicago",
    },
    {
      id: 1,
      title: "Exclusive Wine Tasting Event",
      category: { name: "Food & Drink" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746852044/Artboard_19_1_y0eh0k.svg",
      user_profile: {
        photo: "user1.jpg",
        first_name: "John",
        last_name: "Smith",
      },
      event_date: "15-05-2023 19:00",
      city: "New York",
    },
    {
      id: 2,
      title: "Tech Entrepreneurs Meetup",
      category: { name: "Business" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746946644/new_kcjwxk.svg",
      user_profile: {
        photo: "user2.jpg",
        first_name: "Sarah",
        last_name: "Johnson",
      },
      event_date: "20-05-2023 18:30",
      city: "San Francisco",
    },
    {
      id: 3,
      title: "Yoga & Meditation Retreat",
      category: { name: "Wellness" },
      media:
        "https://res.cloudinary.com/diecfwnp9/image/upload/v1746852044/Artboard_19_3_wt8isn.svg",
      user_profile: {
        photo: "user3.jpg",
        first_name: "Michael",
        last_name: "Chen",
      },
      event_date: "25-05-2023 08:00",
      city: "Los Angeles",
    },
  ];
  return (
    <>
      <ToastContainer />

      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <div className="hidden sm:inline">
        <Head />
        <Header setIsVisible={setIsVisible} />
      </div>
      {/* hjkhk */}

      <>
        <Link to={"/mobileSearch"} className="sm:hidden stickynav-custom">
          <div style={{ pointerEvents: "none" }}>
            <Head />
            <Header setIsVisible={setIsVisible} />
          </div>
        </Link>
        <div className="hidden sm:inline">
          <ImageSliderHero setIsVisible={setIsVisible} dummyData={dummyData} />
        </div>
        <div className="sm:hidden">
          <ImageSliderHero setIsVisible={setIsVisible} dummyData={dummyData2} />
        </div>
        {/* <div className="sm:hidden">
          <ImageSliderHeroMobile setIsVisible={setIsVisible} />
        </div> */}
        <SlidingTabs setIsVisible={setIsVisible} />
        <Newsstaller />
        <HomeVideoSection />

        <Footer homePage={true} />
      </>
    </>
  );
};

export default Home;
